import { minutesToMilliseconds } from 'date-fns/minutesToMilliseconds';
import { secondsToMilliseconds } from 'date-fns/secondsToMilliseconds';
import { pluralize } from 'inflection';

import type { ArtifactTypeConfig } from './artifacts.models';
import { ArtifactType, artifactTypeMetadata } from './common/artifact-type';

export * from './artifact-analysis/vulnerability-list/vulnerability-annotations.const';

/**
 * Legacy artifact type configuration array, derived from artifactTypeMetadata.
 * @see artifactTypeMetadata for the source of truth
 */
export const artifactTypes: ArtifactTypeConfig[] = Object.entries(
  artifactTypeMetadata,
)
  .map(([id, { label, title = label, icon }]) => ({
    id: id as ArtifactType,
    typeName: label,
    title: pluralize(title),
    titleSingular: title,
    icon,
  }))
  // Maintain the order of the previous static definition to avoid breaking fragile code
  .sort((a, b) => {
    const order = [ArtifactType.Source, ArtifactType.Image, ArtifactType.SBOM];
    return order.indexOf(a.id) - order.indexOf(b.id);
  });

// Compliance Alert polling intervals (in milliseconds)
export const COMPLIANCE_ALERT_POLLING_INTERVAL_MS = minutesToMilliseconds(5);
export const COMPLIANCE_ALERT_EAGER_UPDATE_INTERVAL_MS =
  secondsToMilliseconds(10);
